<template>
  <VCard
    class="footer-menu shadow-none col-lg-6 col-md-6 pt-0"
    tile
  >
    <VList
      class="grey darken-3 flex-wrap justify-center"
      :class="{'flex-column': $vuetify.breakpoint.smAndDown, 'd-flex': $vuetify.breakpoint.mdAndUp}"
    >
      <!-- eslint-disable-next-line -->
     <!-- //NOSONAR --><VListItem  :href="item.isAnotherDomain ? item.path.name : ''"
                          v-for="(item, index) in menuItems"
                          :key="index"
                          :target="item.isAnotherDomain ? '_blank' : ''"
                          :to="!item.isAnotherDomain ? item.path : ''"
                          :class="`item-${item.path} d-flex px-2`"
                          link
      ><VListItemContent
         class="py-2"
        >
          <VListItemTitle class="d-flex justify-center heading-6 textWhite--text text-capitalize">
              {{ item.strapiText || $t(item.title) }}
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        v-if="isShownPrivacyPreferences"
        tabindex="0"
        @click="$emit('openCookieDialog')"
        @keydown.enter="$emit('openCookieDialog')"
        @keydown.space.prevent="$emit('openCookieDialog')"
      >
        <VListItemContent
         class="py-2"
        >
          <VListItemTitle class="d-flex justify-center heading-6 textWhite--text text-capitalize">
            {{ $t('cookieManagement.privacyPreferences') }}
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
    </VList>
  </VCard>
</template>

<script lang="ts">
export default {
  name: 'FooterMenu',
};
</script>

<script setup lang="ts">
defineProps({
  menuItems: {
    type: Array,
    default: () => [],
  },
  isShownPrivacyPreferences: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
@import "@slg/web-customer-shared/src/style/variables.scss";
.footer-menu {
  background: inherit;
  .v-list {
    .v-list-item {
      flex: unset;
      &:hover {
        text-decoration: none;
        color: rgb(223 230 224);
      }
      &:focus,
      &:focus-within {
        text-decoration: none;
        color: rgb(223 230 224);
        outline: 2px solid var(--v-textTertiary-base);
        outline-offset: 2px;
      }
      &.item-gtc {
        margin-top: 16px;
        padding-top: 16px;
        .v-list-item__title:before {
          content: "\00B7";
          font-size: $fs-20;
          position: absolute;
          color:  var(--v-textTertiary-base) !important;
          bottom: 95%;
          transform: scale(1.5);
        }
      }
    }
  }
  @media screen and (min-width: 960px) {
    .v-list {
      .v-list-item.item-gtc {
        margin-top: 0px;
        padding-top: 0px;
        margin-left: 16px;
        padding-left: 16px;
        .v-list-item__title {
          &:before {
            right: 108%;
            top: 18%;
          }
        }
      }
    }
  }
}

</style>
